import ChallengeService from "@/services/ChallengeService";

export const namespaced = true;

export const state = {
  challenges: [],
  challengesToday: [],
};

export const mutations = {
  setChallenges(state, challenges) {
    state.challenges = challenges;
  },
  setChallengesToday(state, challengesToday) {
    state.challengesToday = challengesToday;
  },
};

export const actions = {
  // User Accounts
  list(
    { commit, dispatch },
    { page, page_size, sort, order, section_id, search_term, platoon_id}
  ) {
    return ChallengeService.list({
      page,
      page_size,
      sort,
      order,
      section_id,
      search_term,
      platoon_id,
    })
      .then((res) => {
        commit("setChallenges", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  add({ dispatch }, challenge) {
    let obj = { ...challenge };
    obj.platoon_id = obj.platoon_id > 0 ? obj.platoon_id : null;
    obj.section_id = obj.section_id > 0 ? obj.section_id : null;
    obj.community_id = obj.community_id ? obj.community_id : 0;

    return ChallengeService.add(obj)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  edit({ dispatch }, user) {
    let obj = { ...user };
    obj.platoon_id = obj.platoon_id > 0 ? obj.platoon_id : null;
    obj.section_id = obj.section_id > 0 ? obj.section_id : null;
    obj.height_cm = obj.height_cm ? obj.height_cm : 0;
    obj.weight_kg = obj.weight_kg ? obj.weight_kg : 0;
    obj.devices = obj.assigned_devices || [];

    obj.devices = obj.devices.filter(
      (d) => d.serial.trim().length > 0 && d.address.trim().length > 0
    );

    return ChallengeService.edit(obj)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  delete({ dispatch }, deleteChallenge) {
    console.log("delete challenge_id", deleteChallenge.challenge_id);
    return ChallengeService.delete(deleteChallenge.challenge_id)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  fetchChallengeDetails({ dispatch }, challengeReq) {
    return ChallengeService.fetchChallengeDetails(challengeReq)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  stop({ dispatch }, challenge_id) {
    return ChallengeService.stop({ challenge_id })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  saveChallengeResults({ dispatch }, challengeResults) {
    return ChallengeService.saveChallengeResults(challengeResults)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  fetchResults({ dispatch }, challenge) {
    console.log("fetch challenge results", challenge);
    return ChallengeService.fetchResults(challenge.challenge_id)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  reStartChallenge({ dispatch }, challengeResults) {
    return ChallengeService.reStartChallenge(challengeResults)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
};
